import { render, staticRenderFns } from "./NewsPost.vue?vue&type=template&id=6ed2af6c&scoped=true"
import script from "./NewsPost.vue?vue&type=script&lang=js"
export * from "./NewsPost.vue?vue&type=script&lang=js"
import style0 from "./NewsPost.vue?vue&type=style&index=0&id=6ed2af6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed2af6c",
  null
  
)

export default component.exports